import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AssignmentSectionQuestionService } from '@examdojo/assignment';
import { ChallengeActivityQuery } from '@examdojo/challenge';
import { EMPTY, filter, switchMap } from 'rxjs';

@Injectable()
export class FetchAssignmentQuestionsOnActiveChallengeActivityService {
  constructor(
    private readonly challengeActivityQuery: ChallengeActivityQuery,
    private readonly assignmentSectionQuestionService: AssignmentSectionQuestionService,
  ) {
    this.handleActiveChallengeActivity().pipe(takeUntilDestroyed()).subscribe();
  }

  private handleActiveChallengeActivity() {
    return this.challengeActivityQuery.activeChallengeActivityId$.pipe(
      filter((challengeActivityId) => !!challengeActivityId),
      switchMap((challengeActivityId) => {
        if (!challengeActivityId) {
          return EMPTY;
        }

        const challengeActivity = this.challengeActivityQuery.getEntity(challengeActivityId);
        if (!challengeActivity) {
          return EMPTY;
        }

        return this.assignmentSectionQuestionService.fetchByAssignmentSectionId(
          challengeActivity.assignment_section_id,
        );
      }),
    );
  }
}
